<template>
  <div>
    <v-expansion-panels v-model="panel" multiple>
      <details-form :isCreate="isCreate" :isEdit="isEdit" :rollingBookingRule="rollingBookingRule" :place="place" @autoScroll="openPanel" :isFinalized="rollingBookingRuleIsFinalised(place.rollingBookingRule)" />
      <check-in-days-table id="second" :isCreate="isCreate" :isEdit="isEdit" :bookingRule="rollingBookingRule" @autoScroll="openPanel" :isFinalized="rollingBookingRuleIsFinalised(place.rollingBookingRule)" />
    </v-expansion-panels>
    <div class="text-right mt-8" v-if="!rollingBookingRuleIsFinalised(place.rollingBookingRule)">
      <v-alert v-html="$t('page-rules.base-rule.actions.finalise.warning')" outlined type="warning" text class="mb-2 text-left" v-if="!rollingBookingRuleCanFinalise(place.rollingBookingRule)"
        ></v-alert
      >
      <v-btn v-html="$t('page-rules.base-rule.actions.finalise.button')" color="primary" large @click.stop="finishRuleHandler()" :disabled="!rollingBookingRuleCanFinalise(place.rollingBookingRule)"></v-btn>
    </div>
    <div class="text-right mt-8" v-else>
      <v-btn outlined @click="redirect({name: 'place-rules-manage'})">
        <v-icon left class="px-1">mdi-undo</v-icon>
        Back
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { useBookingRuleStore, useUserStore } from '@/stores'
import DetailsForm from './DetailsForm.vue'
import CheckInDaysTable from './CheckInDaysTable.vue'
import { clone } from 'ramda'

export default {
  data () {
    return {
      saving: false,
      panel: [0],
      valid: true,
      completed: false,
    }
  },
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  methods: {
    clone,
    ...mapActions(useBookingRuleStore, ['httpUpdateRollingBookingRule']),
    finishRuleHandler () {
      const cloneRollingBookingRule = this.clone(this.rollingBookingRule)
      cloneRollingBookingRule.active = true
      this.httpUpdateRollingBookingRule({ rollingBookingRule: cloneRollingBookingRule })
        .then(() => {
          // redirect to base rules page
          this.$router.push({ name: 'place-rules-manage' })
        })
        .catch()
    },
    openPanel (index) {
      this.panel.push(index)
    },
    redirect (to) {
      // using manual redirect as inline :to is causing active styling issues
      this.$router.push(to)
    },
  },
  computed: {
    ...mapState(useUserStore, ['currentUserHasRole']),
    ...mapState(useBookingRuleStore, {
      rollingBookingRuleFindById: 'findById',
      rollingBookingRuleIsFinalised: 'isFinalised',
      rollingBookingRuleCanFinalise: 'canFinaliseBookingRule',
    }),
    rollingBookingRule () {
      return (
        this.rollingBookingRuleFindById(this.place.rollingBookingRule) || {
          place: this.place['@id'],
          label: null,
          duration: 12,
          stayLengths: [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
          ],
        }
      )
    },
    isCreate () {
      return !this.isEdit
    },
    isEdit () {
      return 'id' in this.rollingBookingRule
    },
  },
  mounted () {
    if (this.isEdit) {
      this.panel.push(1, 2, 3)
    }
  },
  components: {
    DetailsForm,
    CheckInDaysTable,
  },
  // beforeRouteLeave (to, from, next) {
  //   this.componentKey++
  //   setTimeout(() => {
  //     next()
  //   }, 100)
  // },
}
</script>
